import script from "./AuthPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthPage.vue?vue&type=script&setup=true&lang=ts"

import "./AuthPage.vue?vue&type=style&index=0&id=364a3dcb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-364a3dcb"]])

export default __exports__